document.addEventListener('DOMContentLoaded', function() {
    const tabTitles = document.querySelectorAll('.gr-info-tabs__title');
    const tabDescriptions = document.querySelectorAll('.gr-info-tabs__description');
  
    tabTitles.forEach(function(title) {
      title.addEventListener('click', function() {
        tabTitles.forEach(function(title) {
          title.classList.remove('gr-info-tabs__title--active');
        });
  
        title.classList.add('gr-info-tabs__title--active');
  
        tabDescriptions.forEach(function(description) {
          description.classList.remove('gr-info-tabs__description--active');
        });
  
        const activeTabId = title.getAttribute('data-tab');
        const activeTabContent = document.getElementById(activeTabId);
        if (activeTabContent) {
          activeTabContent.classList.add('gr-info-tabs__description--active');
        }
      });
    });
});
